<template>
  <div>
    <div class="panel panel-default" id="settlement-top-panel">
      <div class="panel-body">
        <div class="col-md-12">
          <button
            class="btn btn-raised btn-top-bar"
            :disabled="!refreshEnabled"
            @click="getSurveyInstances()"
          >
            <i class="material-icons md-36">refresh</i>
            <template v-if="!isSmallScreen">
              <br />
              {{ lang.SET000 }}
            </template>
          </button>
          <button
            v-if="false"
            class="btn btn-raised btn-top-bar"
            :disabled="selectedSurveys.length === 0"
            @click="openSettlementCheckoutDialog()"
          >
            <i class="material-icons md-36">attach_money</i>
            <template v-if="!isSmallScreen">
              <br />
              {{ lang.SET004 }}
            </template>
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            :disabled="selectedSurveys.length !== 1"
            @click="showSettlementInformationModal = true"
          >
            <i class="material-icons md-36">info_outline</i>
            <template v-if="!isSmallScreen">
              <br />
              {{ lang.SET023 }}
            </template>
          </button>
        </div>
      </div>
      <div class="panel-body">
        <div class="col-xs-6">
          <div class="form-group searchbar">
            <input
              type="search"
              class="form-control"
              id="inputSearch"
              :placeholder="lang.SET002"
              v-model="filterStrings.Search"
              @keyup.enter="(selectedPage = 1), getSurveyInstances()"
            />
          </div>
        </div>
        <div class="col-xs-6" v-if="isSmallScreen">
          <div class="form-group searchbar">
            <select
              class="form-control"
              v-model="filterStrings.SettlementStatusGuid"
              @change="(selectedPage = 1), getSurveyInstances()"
            >
              <option value hidden>{{ lang.SET015 }}</option>
              <option value>{{ lang.SET016 }}</option>
              <option
                v-for="settlementState in settlementStatusList"
                :key="settlementState.SettlementStatusGuid"
                :value="settlementState.SettlementStatusGuid"
              >
                {{ settlementState.SettlementStatusText }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-lg-6 col-xs-12 nopadding">
          <ul class="pagination-fonts pagination btn-group">
            <li>
              <a
                role="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                id="elementsPerPageDropdown"
              >
                <i class="material-icons md-18">view_headline</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="elementsPerPageDropdown"
                :delay="globals.tooltipDelay"
                >{{ lang.SET003 }}</b-tooltip
              >
              <ul class="dropdown-menu">
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 20 }"
                    role="button"
                    @click="updatePaging(1, 20)"
                    >20</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 50 }"
                    role="button"
                    @click="updatePaging(1, 50)"
                    >50</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 100 }"
                    role="button"
                    @click="updatePaging(1, 100)"
                    >100</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 200 }"
                    role="button"
                    @click="updatePaging(1, 200)"
                    >200</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 500 }"
                    role="button"
                    @click="updatePaging(1, 500)"
                    >500</a
                  >
                </li>
              </ul>
            </li>

            <!-- Jump to first page -->
            <li
              v-bind:class="{ disabled: selectedPage == 1 }"
              @click="updatePaging(1, 0)"
            >
              <a role="button" id="firstPageButton">
                <i class="material-icons md-18">first_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="firstPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.SET011 }}</b-tooltip
              >
            </li>
            <!-- ... -->
            <li v-if="pageCount > 7 && selectedPage > 4" class="disabled">
              <a role="button">...</a>
            </li>
            <!-- Pagenumbers -->
            <li
              v-for="pageNumber in getVisiblePages()"
              :key="pageNumber"
              v-bind:class="{ active: selectedPage == pageNumber }"
              @click="updatePaging(pageNumber, 0)"
            >
              <a role="button">{{ pageNumber }}</a>
            </li>
            <!-- ... -->
            <li
              v-if="pageCount > 7 && selectedPage < pageCount - 3"
              class="disabled"
            >
              <a role="button">...</a>
            </li>
            <!-- Jump to last page -->
            <li
              v-bind:class="{ disabled: selectedPage == pageCount }"
              @click="updatePaging(pageCount, 0)"
            >
              <a role="button" id="lastPageButton">
                <i class="material-icons md-18">last_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="lastPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.SET026 }}</b-tooltip
              >
            </li>
            <li class="disabled">
              <a role="button" id="settlementChecksTotalElementsCounter">{{
                checkCount
              }}</a>
              <b-tooltip
                ref="tooltip"
                target="settlementChecksTotalElementsCounter"
                :delay="globals.tooltipDelay"
                >{{ lang.SET027 }}</b-tooltip
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="panel panel-default" id="settlement-table">
      <div class="panel-body">
        <div class="table-space main-table-scrollbar">
          <table class="table table-striped table-hover main-table">
            <thead>
              <tr>
                <th style="width: 10%" class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="orderTableByColumn('SettlementStatusGuid')"
                  >
                    {{ isSmallScreen ? lang.SET017 : lang.SET008 }}
                    <span
                      v-if="showSortArrow('SettlementStatusGuid', true)"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="showSortArrow('SettlementStatusGuid', false)"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th
                  style="width: 10%"
                  class="text-center sticky-header"
                  v-if="!isSmallScreen"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="orderTableByColumn('SurveyInstanceId')"
                  >
                    {{ lang.SET005 }}
                    <span
                      v-if="showSortArrow('SurveyInstanceId', true)"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="showSortArrow('SurveyInstanceId', false)"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th
                  :style="`width:${isSmallScreen ? '40' : '20'}%;`"
                  class="text-center sticky-header"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="orderTableByColumn('SurveyTitle')"
                  >
                    {{ isSmallScreen ? lang.SET013 : lang.SET006 }}
                    <span
                      v-if="showSortArrow('SurveyTitle', true)"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="showSortArrow('SurveyTitle', false)"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th
                  :style="`width:10%;`"
                  class="text-center sticky-header"
                  v-if="!isSmallScreen"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="orderTableByColumn('LocationName')"
                  >
                    {{ isSmallScreen ? lang.SET014 : lang.SET007 }}
                    <span
                      v-if="showSortArrow('LocationName', true)"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="showSortArrow('LocationName', false)"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th
                  :style="`width:15%;`"
                  class="text-center sticky-header"
                  v-if="!isSmallScreen"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="orderTableByColumn('LocationAddress')"
                  >
                    {{ lang.SET024 }}
                    <span
                      v-if="showSortArrow('LocationAddress', true)"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="showSortArrow('LocationAddress', false)"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th
                  :style="`width:5%;`"
                  class="text-center sticky-header"
                  v-if="!isSmallScreen"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="orderTableByColumn('LocationCountry')"
                  >
                    {{ lang.SET025 }}
                    <span
                      v-if="showSortArrow('LocationCountry', true)"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="showSortArrow('LocationCountry', false)"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th
                  :style="`width:${isSmallScreen ? '15' : '10'}%;`"
                  class="text-center sticky-header"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="orderTableByColumn('Total')"
                  >
                    <template v-if="!isSmallScreen">{{ lang.SET010 }}</template>
                    <i v-else class="material-icons md-20">euro_symbol</i>
                    <span
                      v-if="showSortArrow('Total', true)"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="showSortArrow('Total', false)"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th
                  :style="`width:${isSmallScreen ? '15' : '10'}%;`"
                  class="text-center sticky-header"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="orderTableByColumn('SettlementNumber')"
                  >
                    <template v-if="!isSmallScreen">{{ lang.SET012 }}</template>
                    <i v-else class="material-symbols-outlined">#</i>
                    <span
                      v-if="showSortArrow('SettlementNumber', true)"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="showSortArrow('SettlementNumber', false)"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th
                  :style="`width:${isSmallScreen ? '20' : '10'}%;`"
                  class="text-center sticky-header"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="
                      orderTableByColumn('SurveyInstanceShopperSubmittedAt')
                    "
                  >
                    <template v-if="!isSmallScreen">{{ lang.SET009 }}</template>
                    <i v-else class="material-icons md-20">today</i>
                    <span
                      v-if="
                        showSortArrow('SurveyInstanceShopperSubmittedAt', true)
                      "
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="
                        showSortArrow('SurveyInstanceShopperSubmittedAt', false)
                      "
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
              </tr>
              <tr v-if="globals.isLargeScreen()" class="table-filters">
                <th class="nopadding sticky-filter" style="width: 10%">
                  <div
                    class="form-group filterbar"
                    id="settlementStatusFilterContainer"
                  >
                    <Select2
                      class="form-control nopadding"
                      id="settlementStatusFilterSelect"
                      v-model="filterStrings.SettlementStatusGuid"
                      :allowClear="true"
                      :placeholder="lang.SET001"
                      @change="(selectedPage = 1), getSurveyInstances()"
                    >
                      <option></option>
                      <option
                        v-for="settlementState in settlementStatusList"
                        :key="settlementState.SettlementStatusGuid"
                        :value="settlementState.SettlementStatusGuid"
                      >
                        {{ settlementState.SettlementStatusText }}
                      </option>
                    </Select2>
                  </div>
                </th>
                <th class="nopadding sticky-filter" style="width: 10%">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      v-model="filterStrings.SurveyInstanceId"
                      :placeholder="lang.SET001"
                      @keyup.enter="(selectedPage = 1), getSurveyInstances()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter" style="width: 20%">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      v-model="filterStrings.SurveyTitle"
                      :placeholder="lang.SET001"
                      @keyup.enter="(selectedPage = 1), getSurveyInstances()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter" style="width: 10%">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      v-model="filterStrings.LocationName"
                      :placeholder="lang.SET001"
                      @keyup.enter="(selectedPage = 1), getSurveyInstances()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter" style="width: 15%">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      v-model="filterStrings.LocationAddress"
                      :placeholder="lang.SET001"
                      @keyup.enter="(selectedPage = 1), getSurveyInstances()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter" style="width: 5%">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      v-model="filterStrings.LocationCountry"
                      :placeholder="lang.SET001"
                      @keyup.enter="(selectedPage = 1), getSurveyInstances()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter" style="width: 10%">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      v-model="filterStrings.Total"
                      :placeholder="lang.SET001"
                      @keyup.enter="(selectedPage = 1), getSurveyInstances()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter" style="width: 10%">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      v-model="filterStrings.SettlementNumber"
                      :placeholder="lang.SET001"
                      @keyup.enter="(selectedPage = 1), getSurveyInstances()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter" style="width: 10%">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      v-model="filterStrings.SurveyInstanceShopperSubmittedAt"
                      :placeholder="lang.SET001"
                      @keyup.enter="(selectedPage = 1), getSurveyInstances()"
                    />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="main-table-scrollbar">
              <tr
                role="button"
                :key="survey.SurveyInstanceGuid"
                :class="{ info: isSurveySelected(survey.SurveyInstanceGuid) }"
                class="text-center"
                v-for="survey in surveyInstances"
                @click="selectSurveys(survey.SurveyInstanceGuid, $event)"
                v-longclick="
                  () => (selectedSurveys = [survey.SurveyInstanceGuid])
                "
              >
                <td
                  id="materialIconCell"
                  :style="`width:${isSmallScreen ? '10' : '10'}%;`"
                  class="nopadding"
                >
                  <!-- status in progress -->
                  <i
                    class="material-icons md-24"
                    v-if="
                      survey.SettlementStatusGuid ===
                      '5D298073-70E7-472F-9E01-AF19E2BA1C03'
                    "
                    >autorenew</i
                  >
                  <!-- status open -->
                  <i
                    class="material-icons md-24"
                    v-if="
                      survey.SettlementStatusGuid ===
                      '31F176F1-6D31-4F88-BDC5-B62F4EFB5107'
                    "
                    >add_circle_outline</i
                  >
                  <!-- status completed -->
                  <i
                    class="material-icons md-24"
                    v-if="
                      survey.SettlementStatusGuid ===
                      '39E928BA-82BA-4ADD-9E89-04AE44CBCA04'
                    "
                    >check_circle</i
                  >
                </td>
                <td style="width: 10%" v-if="!isSmallScreen">
                  {{ survey.SurveyInstanceId }}
                </td>
                <td :style="`width:${isSmallScreen ? '40' : '20'}%;`">
                  {{ survey.SurveyTitle }}
                </td>
                <td v-if="!isSmallScreen" :style="`width:10%;`">
                  {{ survey.LocationName }}
                </td>
                <td v-if="!isSmallScreen" :style="`width:15%;`">
                  {{ survey.LocationAddress }}
                </td>
                <td v-if="!isSmallScreen" :style="`width:5%;`">
                  {{ survey.LocationCountry }}
                </td>
                <td :style="`width:${isSmallScreen ? '15' : '10'}%;`">
                  {{ globals.getCurrencyString(survey.Total, "EUR") }}
                </td>
                <td :style="`width:${isSmallScreen ? '15' : '10'}%;`">
                  {{ survey.SettlementNumber }}
                </td>
                <td :style="`width:${isSmallScreen ? '20' : '10'}%;`">
                  {{ survey.SurveyInstanceShopperSubmittedAt }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <SettlementCheckoutDialog
      v-if="false"
      :showDialog="showSettlementCheckoutDialog"
      :selectedSurveys="selectedSurveys"
      @dialogClosed="closeSettlementCheckoutDialog"
      @dialogDataSaved="onDialogDataSaved"
    ></SettlementCheckoutDialog>

    <SettlementInformationModal
      :showModal="showSettlementInformationModal"
      :checkData="firstSelectedCheckData"
      @closeModal="showSettlementInformationModal = false"
    ></SettlementInformationModal>
  </div>
</template>

<script>
import SettlementCheckoutDialog from "./SettlementCheckoutDialog";
import SettlementInformationModal from "./SettlementInformationModal";
import Select2 from "../Tools/Select2";

export default {
  name: "SettlementList",
  components: {
    SettlementCheckoutDialog,
    SettlementInformationModal,
    Select2,
  },
  data() {
    return {
      isSmallScreen: false,
      refreshEnabled: false,
      surveyInstances: [],
      pageSize: 20,
      selectedPage: 1,
      pageCount: 0,
      checkCount: 0,
      currentSort: { key: "SettlementStatusGuid", asc: true },
      showSettlementCheckoutDialog: false,
      showSettlementInformationModal: false,
      selectedSurveys: [],
      lastSelectedSurvey: -1,
      settlementStatusList: {},
      filterStrings: {
        Search: "",
        SurveyInstanceId: "",
        SurveyTitle: "",
        LocationName: "",
        SettlementStatusGuid: "",
        SurveyInstanceShopperSubmittedAt: "",
        Total: "",
        SettlementNumber: "",
      },
      lang: {
        SET000: "Refresh",
        SET001: "Filter",
        SET002: "Search...",
        SET003: "Items per page",
        SET004: "Settle",
        SET005: "CheckID",
        SET006: "Project",
        SET007: "Location",
        SET008: "Invoice State",
        SET009: "Submitted At",
        SET010: "Payment",
        SET011: "First page",
        SET012: "Invoice Number",
        SET013: "Project",
        SET014: "Where?",
        SET015: "Status...",
        SET016: "All",
        SET017: "State",
        SET018: "Notification",
        SET019: "Close",
        SET020:
          "The invoice was already initiated for some of the selected checks.",
        SET021: "Please only select checks with an open invoice state.",
        SET022: "Check data request failed",
        SET023: "Info",
        SET024: "Address",
        SET025: "Country",
        SET026: "Last page",
        SET027: "Total check count",
      },
    };
  },
  computed: {
    firstSelectedCheckData() {
      if (this.selectedSurveys.length < 1) return {};
      return _.find(
        this.surveyInstances,
        (s) => s.SurveyInstanceGuid === this.selectedSurveys[0]
      );
    },
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
      this.getSurveyInstances();
    },
  },
  mounted() {
    this.globals.getSettlementStatusList((callbackData) => {
      this.settlementStatusList = callbackData;
    });

    if (this.globals.selectedLanguage) {
      this.getSurveyInstances();
      this.globals.getLanguageStrings(this);
    }

    // Sets the new table height after the window got resized
    let resizeFunc = () => {
      this.isSmallScreen = this.globals.isSmallScreen();
      this.$nextTick(() => {
        this.setElementHeights();
        this.$forceUpdate();
      });
    };
    $(window).off("resize", resizeFunc);
    $(window).on("resize", resizeFunc).resize();
  },
  methods: {
    getSurveyInstances() {
      this.selectedSurveys = [];

      let queryString = `/shopper-api/Settlement/SurveyInstances?page_size=${
        this.pageSize
      }&page=${this.selectedPage}&sort_column=${
        this.currentSort.key
      }&sort_order=${this.currentSort.asc ? "asc" : "desc"}`;

      let filter = _.pickBy(this.filterStrings, (value, key) => {
        return value.length > 0;
      });
      this.refreshEnabled = false;

      $.ajax({
        method: "POST",
        url: queryString,
        data: _.isEmpty(filter) ? "" : JSON.stringify({ Filter: filter }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (!_.isEmpty(data)) {
            this.surveyInstances = data[0].SurveyInstances;
            this.pageCount = data[0].Page_Count;
            this.selectedPage = data[0].Page;
            this.pageSize = data[0].Page_Size;
            this.checkCount = data[0].Count;
          }
        },
        error: () => {
          console.error("Error on POST in getSurveyInstances()");
          this.globals.showErrorSnackbar(this.lang.SET022);
        },
        complete: () => {
          this.refreshEnabled = true;
        },
      });
    },
    openSettlementCheckoutDialog() {
      return; // OT-3 disable checkout
      let canOpenDialog = true;
      this.selectedSurveys.forEach((selectedSurvey) => {
        let survey = this.surveyInstances.find(
          (surveyInstance) =>
            surveyInstance.SurveyInstanceGuid === selectedSurvey
        );
        // 5D298073-70E7-472F-9E01-AF19E2BA1C03 -> in progress
        // 39E928BA-82BA-4ADD-9E89-04AE44CBCA04 -> completed
        if (
          survey.SettlementStatusGuid !== "31F176F1-6D31-4F88-BDC5-B62F4EFB5107"
        )
          canOpenDialog = false;
      });
      if (canOpenDialog) this.showSettlementCheckoutDialog = true;
      else
        this.globals.$emit(
          "openGlobalNotificationDialog",
          this.getNotificationDialogData()
        );
    },
    getNotificationDialogData() {
      return {
        initiator: "SettlementList",
        notificationTitle: this.lang.SET018,
        closeButtonText: this.lang.SET019,
        htmlText: `<p>${this.lang.SET020}</p>
                   <p>${this.lang.SET021}</p>`,
      };
    },
    closeSettlementCheckoutDialog() {
      this.showSettlementCheckoutDialog = false;
    },
    selectSurveys(surveyGuid, e) {
      if (!e) return;

      if ((e.ctrlKey && !e.shiftKey) || this.globals.isMobileBrowser) {
        let idx = _.indexOf(this.selectedSurveys, surveyGuid);
        if (idx > -1) {
          _.pullAt(this.selectedSurveys, idx);
          this.lastSelectedSurvey = -1;
        } else {
          this.selectedSurveys.push(surveyGuid);
          this.lastSelectedSurvey = surveyGuid;
        }
      } else if (!e.ctrlKey && e.shiftKey) {
        document.getSelection().removeAllRanges();
        if (this.lastSelectedSurvey < 0) return;
        let idx1 = _.findIndex(this.surveyInstances, (c) => {
          return c.SurveyInstanceGuid === this.lastSelectedSurvey;
        });
        let idx2 = _.findIndex(this.surveyInstances, (c) => {
          return c.SurveyInstanceGuid === surveyGuid;
        });

        if (idx1 > idx2) [idx2, idx1] = [idx1, idx2];

        for (let i = idx1; i <= idx2; i++) {
          if (
            !this.isSurveySelected(this.surveyInstances[i].SurveyInstanceGuid)
          )
            this.selectedSurveys.push(
              this.surveyInstances[i].SurveyInstanceGuid
            );
        }
      } else {
        this.selectedSurveys = [surveyGuid];
        this.lastSelectedSurvey = surveyGuid;
      }
      this.$forceUpdate();
    },
    isSurveySelected(surveyGuid) {
      return _.indexOf(this.selectedSurveys, surveyGuid) > -1;
    },
    updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getSurveyInstances();
    },
    getRange(min, max, step) {
      var range = [],
        j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },
    getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (
        this.pageCount > 7 &&
        this.selectedPage >= this.pageCount - 3
      ) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },
    showSortArrow(key, asc) {
      return this.currentSort.key === key && this.currentSort.asc === asc;
    },
    orderTableByColumn(orderProp) {
      if (!orderProp && !this.currentSort.key) return;
      if (orderProp) {
        this.currentSort.key === orderProp
          ? (this.currentSort.asc = !this.currentSort.asc)
          : (this.currentSort = { asc: true, key: orderProp });
      }
      this.getSurveyInstances();
    },
    setElementHeights() {
      let height = $(window).height();

      height -=
        $("#settlement-top-panel").height() +
        $(".main-table > thead").height() +
        47;
      //$(".table-space").css("max-height", height);
      //$(".main-table-scrollbar").css("max-height", height);
      //let table = $(".main-table-scrollbar");
      //table.css("max-height", height);

      // Set top for Filter, that it doesent scroll over table-header
      height = $(".main-table thead tr").height();
      $(".sticky-filter").css("top", height);
      /* 
      if (
        this.globals.isMobileBrowser &&
        this.globals.isScreenOrientationLandscape()
      ) {
        table.css("overflow-y", "visible");
        table.css("height", "0");
      } else {
        table.css("overflow-y", "");
        table.css("height", "");
      }
 */
    },
    onDialogDataSaved() {
      this.getSurveyInstances();
    },
  },
};
</script>

<style>
#materialIconCell > i {
  margin-top: 6px;
}

#settlementStatusFilterContainer > .select2.select2-container {
  margin: -1px 0 1px 0;
}
#settlementStatusFilterContainer .select2-selection {
  background: transparent;
}
#settlementStatusFilterContainer
  .select2-selection
  .select2-selection__rendered {
  text-align: center;
}
</style>

<style scoped>
.main-table-scrollbar .material-icons {
  position: relative;
  top: -3px;
}
.filterbar > input {
  max-height: 35px;
  font-size: 12px;
}

.material-icons.md-18 {
  font-size: 18px;
}

.material-icons.md-20 {
  font-size: 50px;
}

.material-icons.md-36 {
  font-size: 36px;
}

table.main-table {
  font-size: 14px;
}

.material-symbols-outlined {
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 48;
  font-size: 42px;
}

@media (max-width: 1000px) {
  .material-icons.md-18 {
    font-size: 24px;
  }
  .material-icons.md-24 {
    font-size: 36px;
  }
  .material-icons.md-36 {
    font-size: 48px;
  }

  @media screen and (max-aspect-ratio: 13/9) {
    .main-table .table-header {
      font-size: 1.2em;
    }
    #settlement-table {
      user-select: none;
    }
    /* .material-icons.md-18 {
      font-size: 36px;
    }
    .material-icons.md-24 {
      font-size: 48px;
    }
    .material-icons.md-36 {
      font-size: 72px;
    } */
    @media only screen and (hover: none) and (pointer: coarse) {
      table.main-table > thead > tr > th {
        font-size: 32px !important;
      }
      table.main-table {
        font-size: 26px;
      }
      .pagination-fonts {
        font-size: 32px;
      }
      .form-control {
        font-size: 32px !important;
      }
      .material-icons.md-18 {
        font-size: 36px;
      }
      .material-icons.md-24 {
        font-size: 48px;
      }
      .material-icons.md-36 {
        font-size: 72px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// SettlementList.vue?74cd20a9